import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  title: {
    fontSize: '2.4rem',
    fontWeight: 600,
    color: theme.colors.primary,
    lineHeight: 1.16,
    position: 'relative',
    width: 'auto',
    textAlign: 'left',
    textTransform: 'initial',
    paddingBottom: '0.5em',
    '&:after': {
      content: '""',
      position: 'absolute',
      height: 3,
      width: 50,
      backgroundColor: theme.colors.secondary,
      left: 0,
      bottom: 0,
    },
    [`@media (min-width: ${theme.mediaQueries.tabletLandscape}px)`]: {
      fontSize: '3.6rem',
    },
  },
}))

export default useStyles
